import { GALLERY_IMAGES } from "../../data/constants";
import styles from "./GalleryTicker.module.css";

// Duplicate images for seamless infinite loop
const DOUBLED = [...GALLERY_IMAGES, ...GALLERY_IMAGES];

export default function GalleryTicker() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.track}>
        {DOUBLED.map((src, i) => (
          <img
            key={i}
            className={styles.img}
            src={src}
            alt=""
            loading="lazy"
            aria-hidden="true"
          />
        ))}
      </div>
    </div>
  );
}
